import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import axios from "axios";
import api from "../api/axiosInstance";
import NavigationBar from "../layout/NavigationBar";
import Footer from "../layout/footer";

function Payment() {
    const [countdown, setCountdown] = useState({
        days: 30,
        hours: 12,
        minutes: 45,
        seconds: 30
    });
    const [paymentAccountData, setPaymentAccountData] = useState(null);
    const [loading, setLoading] = useState(true);
    const business_id = window.localStorage.getItem("business_id");
    const [email, setEmail] = useState('');
    const [isSubscribed, setIsSubscribed] = useState(false);

    const [showEditModal, setShowEditModal] = useState(false);
    const [formData, setFormData] = useState({
        email: '',
        phone: '',
        legalBusinessName: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        postal_code: '',
        contactName: ''
    });
    const [updating, setUpdating] = useState(false);


    // Animated countdown timer
    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown(prev => {
                let { days, hours, minutes, seconds } = prev;

                if (seconds > 0) {
                    seconds--;
                } else if (minutes > 0) {
                    minutes--;
                    seconds = 59;
                } else if (hours > 0) {
                    hours--;
                    minutes = 59;
                    seconds = 59;
                } else if (days > 0) {
                    days--;
                    hours = 23;
                    minutes = 59;
                    seconds = 59;
                }

                return { days, hours, minutes, seconds };
            });
        }, 1000);

        return () => clearInterval(timer);
    }, []);
    useEffect(() => {
        fetchPaymentAccountDetails();
    }, []);


    const fetchPaymentAccountDetails = async () => {
        try {
            // Step 1: Get store info to retrieve seller_account_id and product_config_id
            const storeInfoResponse = await api.get(
                '/business/store/info', { params: { business_id } }
            );

            if (storeInfoResponse.data.status === "success") {
                const storeData = storeInfoResponse.data.result;
                const accountId = storeData.seller_account_id;
                const productId = storeData.product_config_id;

                // Step 2: Get linked account details
                const linkedAccountResponse = await api.post(
                    '/pay/getLinkedAccount',
                    {
                        account_id: accountId,
                        business_id: business_id
                    }
                );

                // Step 3: Get product config (bank details)
                const productConfigResponse = await api.post(
                    '/pay/getProductConfig',
                    {
                        account_id: accountId,
                        business_id: business_id,
                        product_id: productId
                    }
                );

                if (linkedAccountResponse.data.success && productConfigResponse.data.success) {
                    const accountDetails = linkedAccountResponse.data.accountDetails;
                    const settlements = productConfigResponse.data.productConfigDetails.active_configuration.settlements;

                    // Combine data into the format expected by the component
                    const combinedData = {
                        legalBusinessName: accountDetails.legal_business_name,
                        email: accountDetails.email,
                        phone: accountDetails.phone,
                        contactName: accountDetails.contact_name,
                        address1: accountDetails.profile.addresses.registered.street1,
                        city: accountDetails.profile.addresses.registered.city,
                        state: accountDetails.profile.addresses.registered.state,
                        postal_code: accountDetails.profile.addresses.registered.postal_code,
                        account_number: settlements.account_number,
                        ifsc: settlements.ifsc_code,
                        beneficiary_name: settlements.beneficiary_name,
                        account_id: accountDetails.id,
                        activation_status: productConfigResponse.data.productConfigDetails.activation_status
                    };

                    setPaymentAccountData(combinedData);
                }
            }
        } catch (error) {
            console.error('Error fetching payment account:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleEditClick = () => {
        setFormData({
            email: paymentAccountData.email,
            phone: paymentAccountData.phone,
            legalBusinessName: paymentAccountData.legalBusinessName,
            address1: paymentAccountData.address1,
            address2: '',
            city: paymentAccountData.city,
            state: paymentAccountData.state,
            postal_code: paymentAccountData.postal_code,
            contactName: paymentAccountData.contactName
        });
        setShowEditModal(true);
    };

    // Add this function to handle form input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Add this function to handle form submission
    const handleUpdateSubmit = async (e) => {
        e.preventDefault();
        setUpdating(true);

        try {
            const cleanedPhone = formData.phone.replace(/\D/g, '');

            const response = await api.post(
                '/pay/updateSeller',
                {
                    email: formData.email,
                    phone: cleanedPhone,
                    legalBusinessName: formData.legalBusinessName,
                    address1: formData.address1,
                    address2: formData.address2,
                    city: formData.city,
                    state: formData.state,
                    postal_code: formData.postal_code,
                    contactName: formData.contactName,
                    business_id: business_id,
                    account_id : paymentAccountData.account_id
                }
            );

            if (response.data.success) {
                alert('Details updated successfully!');
                setShowEditModal(false);
                fetchPaymentAccountDetails(); // Refresh the data
            }
        } catch (error) {
            console.error('Error updating details:', error);
            alert('Failed to update details. Please try again.');
        } finally {
            setUpdating(false);
        }
    };

    const handleNotifyMe = (e) => {
        e.preventDefault();
        if (email) {
            setIsSubscribed(true);
            setEmail('');
            // Here you would typically send the email to your backend
            setTimeout(() => setIsSubscribed(false), 3000);
        }
    };

    return (
        <div className="wrapper" id="root">
            <header>
                <NavigationBar />
            </header>

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 txt_lft">Payments</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="content">
                    <div className="container-fluid">

                        {loading ? (
                            <div className="text-center">
                                <i className="fas fa-spinner fa-spin fa-3x"></i>
                            </div>
                        ) : paymentAccountData ? (
                            <div className="row">
                                {/* Account Status Card */}
                                <div className="col-md-12 mb-4">
                                    <div className="card">
                                        <div className="card-header bg-success text-white">
                                            <h3 className="card-title">
                                                <i className="fas fa-check-circle mr-2"></i>
                                                Payment Account Active
                                            </h3>
                                        </div>
                                    </div>
                                </div>

                                {/* Business Details */}
                                <div className="col-md-6">
                                    <div className="card">
                                        <div className="card-header">
                                            <h4><i className="fas fa-building mr-2"></i>Business Information</h4>
                                        </div>
                                        <div className="card-body">
                                            <table className="table table-sm">
                                                <tbody>
                                                    <tr>
                                                        <td><strong>Business Name:</strong></td>
                                                        <td>{paymentAccountData.legalBusinessName}</td>
                                                    </tr>
                                                    <tr>
                                                        <td><strong>Email:</strong></td>
                                                        <td>{paymentAccountData.email}</td>
                                                    </tr>
                                                    <tr>
                                                        <td><strong>Phone:</strong></td>
                                                        <td>{paymentAccountData.phone}</td>
                                                    </tr>
                                                    <tr>
                                                        <td><strong>Contact Name:</strong></td>
                                                        <td>{paymentAccountData.contactName}</td>
                                                    </tr>
                                                    <tr>
                                                        <td><strong>Address:</strong></td>
                                                        <td>
                                                            {paymentAccountData.address1}<br />
                                                            {paymentAccountData.city}, {paymentAccountData.state}<br />
                                                            {paymentAccountData.postal_code}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                {/* Bank Details */}
                                <div className="col-md-6">
                                    <div className="card">
                                        <div className="card-header">
                                            <h4><i className="fas fa-university mr-2"></i>Bank Account Details</h4>
                                        </div>
                                        <div className="card-body">
                                            <table className="table table-sm">
                                                <tbody>
                                                    <tr>
                                                        <td><strong>Account Number:</strong></td>
                                                        <td>****{paymentAccountData.account_number?.slice(-4)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td><strong>IFSC Code:</strong></td>
                                                        <td>{paymentAccountData.ifsc}</td>
                                                    </tr>
                                                    <tr>
                                                        <td><strong>Beneficiary Name:</strong></td>
                                                        <td>{paymentAccountData.beneficiary_name}</td>
                                                    </tr>
                                                    <tr>
                                                        <td><strong>Account ID:</strong></td>
                                                        <td><code>{paymentAccountData.account_id}</code></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                {/* Action Buttons */}
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-body text-center">
                                            {/* DISABLED: Payment details can only be added once and cannot be edited */}
                                            {/* <button className="btn btn-primary btn-lg mr-3" onClick={handleEditClick}>
                                                <i className="fas fa-edit mr-2"></i>Edit Details
                                            </button> */}
                                            {/* <button className="btn btn-info btn-lg">
                                                <i className="fas fa-download mr-2"></i>Download Statement
                                            </button> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div style={{
                                minHeight: '70vh',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                background: 'linear-gradient(135deg, #1E5B3A 0%, #2E7D4F 100%)',
                                borderRadius: '20px',
                                margin: '20px 0',
                                position: 'relative',
                                overflow: 'hidden'
                            }}>
                                {/* Animated Background Elements */}
                                <div style={{
                                    position: 'absolute',
                                    top: '10%',
                                    left: '10%',
                                    width: '100px',
                                    height: '100px',
                                    borderRadius: '50%',
                                    background: 'rgba(255, 255, 255, 0.1)',
                                    animation: 'float 6s ease-in-out infinite'
                                }}></div>
                                <div style={{
                                    position: 'absolute',
                                    top: '20%',
                                    right: '15%',
                                    width: '60px',
                                    height: '60px',
                                    borderRadius: '50%',
                                    background: 'rgba(255, 255, 255, 0.1)',
                                    animation: 'float 4s ease-in-out infinite reverse'
                                }}></div>
                                <div style={{
                                    position: 'absolute',
                                    bottom: '15%',
                                    left: '20%',
                                    width: '80px',
                                    height: '80px',
                                    borderRadius: '50%',
                                    background: 'rgba(255, 255, 255, 0.1)',
                                    animation: 'float 5s ease-in-out infinite'
                                }}></div>

                                {/* Main Content */}
                                <div style={{
                                    textAlign: 'center',
                                    color: 'white',
                                    zIndex: 2,
                                    maxWidth: '600px',
                                    padding: '0 20px'
                                }}>
                                    {/* Icon */}
                                    <div style={{
                                        fontSize: '80px',
                                        marginBottom: '30px',
                                        animation: 'pulse 2s ease-in-out infinite'
                                    }}>
                                        💳
                                    </div>

                                    {/* Title */}
                                    <h1 style={{
                                        fontSize: '3.5rem',
                                        fontWeight: 'bold',
                                        marginBottom: '20px',
                                        textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
                                    }}>
                                        Coming Soon
                                    </h1>

                                    {/* Subtitle */}
                                    <p style={{
                                        fontSize: '1.3rem',
                                        marginBottom: '40px',
                                        opacity: 0.9,
                                        lineHeight: '1.6'
                                    }}>
                                        We're working hard to bring you the most secure and seamless payment experience.
                                        Get ready for lightning-fast transactions and world-class security!
                                    </p>

                                </div>

                                {/* CSS Animations */}
                                <style jsx>{`
                                @keyframes float {
                                    0%, 100% { transform: translateY(0px); }
                                    50% { transform: translateY(-20px); }
                                }
                                
                                @keyframes pulse {
                                    0%, 100% { transform: scale(1); }
                                    50% { transform: scale(1.1); }
                                }
                                
                                @media (max-width: 768px) {
                                    h1 { font-size: 2.5rem !important; }
                                    p { font-size: 1.1rem !important; }
                                }
                            `}</style>
                            </div>
                        )}
                        {showEditModal && (
                            <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title">Edit Payment Account Details</h5>
                                            <button type="button" className="close" onClick={() => setShowEditModal(false)}>
                                                <span>&times;</span>
                                            </button>
                                        </div>
                                        <form onSubmit={handleUpdateSubmit}>
                                            <div className="modal-body">
                                                <div className="row">
                                                    <div className="col-md-6 form-group">
                                                        <label>Business Name *</label>
                                                        <input
                                                            type="text"
                                                            name="legalBusinessName"
                                                            className="form-control"
                                                            value={formData.legalBusinessName}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="col-md-6 form-group">
                                                        <label>Contact Name *</label>
                                                        <input
                                                            type="text"
                                                            name="contactName"
                                                            className="form-control"
                                                            value={formData.contactName}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="col-md-6 form-group">
                                                        <label>Email *</label>
                                                        <input
                                                            type="email"
                                                            name="email"
                                                            className="form-control"
                                                            value={formData.email}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="col-md-6 form-group">
                                                        <label>Phone *</label>
                                                        <input
                                                            type="tel"
                                                            name="phone"
                                                            className="form-control"
                                                            value={formData.phone}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="col-md-12 form-group">
                                                        <label>Address Line 1 *</label>
                                                        <input
                                                            type="text"
                                                            name="address1"
                                                            className="form-control"
                                                            value={formData.address1}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="col-md-12 form-group">
                                                        <label>Address Line 2</label>
                                                        <input
                                                            type="text"
                                                            name="address2"
                                                            className="form-control"
                                                            value={formData.address2}
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>
                                                    <div className="col-md-4 form-group">
                                                        <label>City *</label>
                                                        <input
                                                            type="text"
                                                            name="city"
                                                            className="form-control"
                                                            value={formData.city}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="col-md-4 form-group">
                                                        <label>State *</label>
                                                        <input
                                                            type="text"
                                                            name="state"
                                                            className="form-control"
                                                            value={formData.state}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="col-md-4 form-group">
                                                        <label>Postal Code *</label>
                                                        <input
                                                            type="text"
                                                            name="postal_code"
                                                            className="form-control"
                                                            value={formData.postal_code}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-secondary" onClick={() => setShowEditModal(false)}>
                                                    Cancel
                                                </button>
                                                <button type="submit" className="btn btn-primary" disabled={updating}>
                                                    {updating ? (
                                                        <>
                                                            <i className="fas fa-spinner fa-spin mr-2"></i>Updating...
                                                        </>
                                                    ) : (
                                                        <>
                                                            <i className="fas fa-save mr-2"></i>Save Changes
                                                        </>
                                                    )}
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Payment;